<template>
  <section class="money-wrapper vh100"
           style="height: 100%;">
    <section class="money" :class="this.provide ? 'money-ciba': ''"
             :style="this.searching ? {'padding': '0', 'background': '#fff'} : {}">
      <div class="money-header" :class="this.provide ? 'money-header-ciba': ''" v-if="!searching">
        <div class="money-header-strategy"
             :class="this.provide ? 'money-header-strategy-ciba': ''"
             @click="handleNavigate('/knowledge-show')"></div>
        <div class="money-header-ques"
             :class="this.provide ? 'money-header-ques-ciba': ''"
             @click="() => { isPopupVisible = true, popupType = 1 }">奖励金规则
        </div>
        <div class="money-header-count" :class="this.provide ? 'money-header-count-ciba': ''"><span>{{ wealthData.balance }}</span>元
        </div>
        <div class="money-header-link"
             @click="$router.push('/wealth/detail')">查看明细
        </div>
        <div class="money-header-button"
             :class="this.provide ? 'money-header-button-ciba': ''"
             @click="handleDraw">{{buttonMessage}}
        </div>
      </div>
      <div class="money-text" v-if="!this.provide">赚取更多奖励金</div>
      <div class="money-ciba-text"
            v-clipboard="() => shareUrl"
            v-clipboard:success="() => this.$toast.show({message: '复制成功'})"
            v-if="this.provide && !this.searching">
        复制优惠券链接
      </div>
      <div class="money-task" :style="this.searching ? {'border-radius': '0'} : {}">
        <div class="money-task-title" v-if="!this.searching">{{this.provide? '赚取更多奖励金' : '邀请任务'}}</div>
        <div class="money-task-input">
          <input type="search"
                 v-model="inputValue"
                 v-if="this.provide"
                 :style="this.searching ? {'margin': '0', 'border-radius': '5px', 'text-align': 'left'} : {}"
                 :placeholder="this.searching? '请输入课程关键字': '搜索课程'"
                 @search="search"
                 @focus="handlerFocus">
          <span v-if="searching" @click="handlerClick">取消</span>
        </div>

        <ul class="money-task-list" :class="this.provide ? 'money-task-list-ciba': ''">
          <li v-for="(course, index) in invitationCourse"
              :key="course.id"
              :data-earning="course.earnMoney || course.money"
              @click="handleNavigate(`/poster?courseId=${ course.courseId }&type=1`, index + 1, course.shareUrl)">
            <div class="money-task-image"
                 :style="{ 'background-image': `url(${ course.image || course.teacherImgUrl })` }"></div>
            <div class="money-task-info">
              <div class="money-task-info-title">{{ course.title || course.courseName }}</div>
              <!-- <div class="money-task-info-text">
                  好友参加课程，得<span>{{ course.earnMoney }}</span>元红包
              </div> -->
              <div class="money-task-info-text">
                好友通过你的分享参加课程，{{provide ? '立得' : '立减'}}<span>{{provide ? course.money : 20}}</span>元
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <screen-wrapper
      v-if="isPopupVisible"
      :show-close=" popupType === 1 ||popupType === 3 || popupType === 2"
      @close="() => isPopupVisible = false">
      <div class="money-popup">
        <div class="money-popup-box">
          <!-- 常见问题 -->
          <div v-if="popupType === 1">
            <div class="money-popup-title">奖励金规则</div>
            <div class="money-popup-question">
              <p>怎么赚取奖励金？</p>
              <p>点击课程页面右上角“赚XX元”，生成专属您的心仪海报发送给好友，好友通过二维码购买课程，您即可赚取相应的奖励金，多买多得！同时您的好友还能立即获取20元优惠券（24小时内有效），购买立省20元哦~</p>
            </div>
            <div class="money-popup-question">
              <p>奖励金如何提现？</p>
              <p>1）点击“我要提现”，即可收到公众号发放的微信红包，点击即可领取至微信零钱。未关注微课公众号的用户无法提现，请先关注公众号后再发起提现流程。</p>
              <p>2）根据国家税法相关规定，提现金额超过800元将需缴纳个人所得税，故每月最多能提现800元，余下金额可顺延至下月再提取。</p>
            </div>
          </div>
          <!-- 领取金额达到上限 -->
          <div v-if="popupType === 2">
            <div class="money-popup-title">温馨提示</div>
            <div class="money-popup-text">
              <p>您本月提现金额已达上限，</p>
              <p>请下个月再进行提取哦~</p>
            </div>
          </div>
          <!-- 未关注公众号 -->
          <div v-if="popupType === 3">
            <div class="money-popup-icon heart"></div>
            <div class="money-popup-title">温馨提示</div>
            <div class="money-popup-text">
              <p>提现金额将通过微信红包在<span style="color: #ff6f25;">【微课】公众号</span>发放</p>
              <p>请先关注公众号</p>
            </div>
            <!-- <div class="money-popup-wx"></div> -->
            <img src="../assets/images/money-popup-icon-wx.png"
                 class="money-popup-wx">
            <div class="money-popup-tip">
              <p>长按扫描二维码</p>
              <p>或保存图片扫码进行关注</p>
            </div>
          </div>
          <!-- 领取成功 -->
          <div v-if="popupType === 4">
            <div class="money-popup-icon success"></div>
            <div class="money-popup-title">提现成功</div>
            <div class="money-popup-text">
              <p>请在精品课公众号领取红包</p>
              <!-- <p>本月还可提现金额为：<span>80元</span></p> -->
            </div>
            <div class="money-popup-button"
                 :style="this.provide ? {'background': 'linear-gradient(to right, #56C3F2, #3BA8FF)'} : {}"
                 @click="() => isPopupVisible = false">我知道了
            </div>
          </div>
          <!-- 身份证审核中 -->
          <div v-if="popupType === 5">
            <div class="money-popup-icon id"></div>
            <div class="money-popup-title">正在审核中...</div>
            <div class="money-popup-text">
              <p style="text-align: left; color: #6d6055;">身份证系统审核中，预计<span style="color: #ff6f25;">1-3个工作日</span>审核成功！审核通过后会提醒您领取现金红包，请耐心等待。
              </p>
            </div>
            <div class="money-popup-button"
                 :style="this.provide ? {'background': 'linear-gradient(to right, #56C3F2, #3BA8FF)'} : {}"
                 @click="() => isPopupVisible = false">好的
            </div>
          </div>
        </div>
      </div>
    </screen-wrapper>
    <div class="red-packet-bubble" v-if="isRedPacketShow">
      <div class="red-packet-bubble-main"
           v-if="isRedPacketShow === 1"
           @click="isRedPacketShow = 2">
        <img src="../assets/images/red-packet-bubble-none.png" alt="">
      </div>
      <div class="red-packet-bubble-main"
           v-if="isRedPacketShow === 2"
           @click="isRedPacketShow = 0">
        <img src="../assets/images/red-packet-bubble.png" alt="">
        <div class="red-packet-bubble-price">{{redBagValue}}</div>
      </div>
    </div>
  </section>
</template>

<script>
  /* eslint-disable */
  import { mapState, mapActions } from 'vuex'
  import ScreenWrapper from '../components/ScreenWrapper'
  import api from '@edu-fe/api'
  import login from '@/utils/login'
  import Clipboard from 'v-clipboard'
  Vue.use(Clipboard)

  export default {
    name: 'Money',
    components: {
      ScreenWrapper
    },
    data () {
      return {
        isPopupVisible: false,
        /**
         * @value
         * 1: 常见问题
         * 2: 领取金额达到上限
         * 3: 未关注公众号
         * 4: 领取成功
         * 5: 身份证审核中
         */
        popupType: 0, // 展示的popup类型
        buttonMessage: '我要提现',
        isRedPacketShow: 0,
        searching: false,
        memory: [],
        inputValue: '',
        inputFocus: false
      }
    },
    computed: mapState({
      wealthData: state => state.wealth.wealthData,
      invitationCourse: state => state.wealth.invitationCourse,
      userId: state => {
        return state.userInfo.userId
      },
      redBagValue () {
        return this.$route.query.redBagValue
      },
      provide () {
        return this.$route.query.provide === 'ciba'
      },
      shareUrl () {
        return `https://edu-ciba.iciba.com/coupon?extra=${this.userId}`
      }
    }),
    watch: {
      redBagValue: {
        handler (val) {
          if (val) {
            this.isRedPacketShow = 1
          }
        },
        immediate: true
      }
    },
    beforeRouteEnter (to, from, next) {
      if (from.name) {
        return next(vm => {
          vm.isRedPacketShow = 0
        })
      }
      next()
    },

    async created () {
      const wpsSid = await login.getWpsSid()

      if (!wpsSid) {
        login.login()
        this.getData()
      } else {
        this.getData()
      }
      await this.getUserInfo()
    },

    mounted () {
      const { popupType } = this.$route.query
      const reloadFlag = window.sessionStorage.getItem('reloadFlag')
      if (popupType && !reloadFlag) {
        this.popupType = parseInt(popupType)
        this.isPopupVisible = true
        window.sessionStorage.setItem('reloadFlag', true)
      }
    },

    methods: {
      ...mapActions([
        'wealth/getWealthData',
        'wealth/getInvitationCourse',
        'wealth/draw',
        'wealth/checkWealthStatus',
        'wealth/dealInvitationCourse',
        'getUserInfo'
      ]),
      handlerFocus () {
        this.searching = true
        this.memory = this.invitationCourse
        this['wealth/dealInvitationCourse']([])
        setTimeout(()=>{
          window.scrollTo(0,0);
        }, 200);
      },
      handlerClick () {
        this.searching = false
        this['wealth/dealInvitationCourse'](this.memory)
        this.inputValue = ''
      },
      async search () {
        await this['wealth/getInvitationCourse'](this.inputValue)
      },
      async getData () {
        this['wealth/getWealthData']()
        this['wealth/getInvitationCourse']()
        const { data } = await this['wealth/checkWealthStatus']()
        // 0：未上传，1待审核，2通过，3未通过
        this.buttonMessage = ['提现审核', '审核中...', '我要提现', '重新审核'][data] || '未知状态'
      },
      handleNavigate (url, index = 0, shareUrl) {
        if (this.provide) {
          window.location.href = shareUrl
          return
        }

        if (url.indexOf('http') !== -1) {
          window.location.href = url
        } else {
          this.$router.push(url)
        }
      },
      handleDraw () {
        switch (this.buttonMessage) {
          case '提现审核':
          case '重新审核':
            return this.$router.push(`/authentication?provide=${this.$route.query.provide}`)
          case '我要提现':
            return this.$router.push(`/withdraw?provide=${this.$route.query.provide}`)
        }
        return
        // 以下是老接口
        this['wealth/draw']().then(res => {
          const { code } = res
          if (code === 1) {
            this.popupType = 4
            this.isPopupVisible = true
          } else if (code === 1001) {
            this.$toast.show({
              message: '不是微信登录的WPS账号'
            })
          } else if (code === 1002) {
            this.popupType = 3
            this.isPopupVisible = true
          } else if (code === 1003) {
            this.popupType = 2
            this.isPopupVisible = true
          } else if (code === 1006) {
            this.popupType = 5
            this.isPopupVisible = true
          } else if (code === 1009) {
            this.$toast.show({
              message: '身份证审核失败，无法提现'
            })
            this.$router.push(`/authentication?provide=${this.$route.query.provide}`)
          } else if (code === 1005) {
            this.$toast.show({
              message: '今日提现已达200上限哦，请明天再来吧'
            })
          } else if (code === 1007) { // 未上传身份证
            this.$router.push(`/authentication?provide=${this.$route.query.provide}`)
          } else {
            this.$toast.show({
              message: res.msg || '网络错误'
            })
          }
        })
      },
      handleClosePopup () {
        this.isPopupVisible = false

        // 提现成功刷新余额
        if (this.popupType === 4) {
          this['wealth/getWealthData']()
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../style/main';

  .red-packet-bubble {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99;
    background-color: rgba(#000, .4);
    text-align: center;
    &-price {
      width: 100%;
      text-align: center;
      &:after {
        content: '元';
        font-size: rem(84);
        color: #A87E56;
        font-weight: bold;
      }
      position: absolute;
      font-size: rem(140);
      color: #A87E56;
      z-index: 999;
      top: rem(176);
      font-weight: bold;
    }
    &-main {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      > img {
        width: rem(630);
      }
    }
  }

  .money {
    overflow-y: scroll;
    padding: 0 rem(30);
    /*height: 100%;*/
    background: url('../assets/images/mine_bgCircle.png') #f3f4f6 center top no-repeat;
    background-size: contain;

    &-ciba {
      background: url('../assets/ciba/ciba_bgCircle.png') #f3f4f6 center top no-repeat;
      background-size: contain;
      &-text {
        background: #6BD076;
        font-size: rem(30);
        font-weight: bold;
        color: #fff;
        padding: rem(29) 0;
        line-height: 1.3;
        margin-top: rem(30);
        margin-bottom: rem(40);
        text-align: center;
        border-radius: rem(5);
      }
    }
    &-header-strategy {
      position: absolute;
      top: rem(30);
      left: 0;
      width: rem(186);
      height: rem(40);
      background: {
        image: url('../assets/images/money-icon-strategy.png');
        size: contain;
        repeat: no-repeat;
      }
      &-ciba {
        background: {
          image: url('../assets/ciba/miney-icon-ciba.png');
          size: contain;
          repeat: no-repeat;
        }
      }
    }

    &-header {
      position: relative;
      margin-top: rem(30);
      padding: rem(80) 0;
      border-radius: 5px;
      background: url('../assets/images/money-header-bg.png') #fff center bottom no-repeat;
      background-size: contain;
      box-shadow: 0 rem(12) rem(15) rgba(0, 0, 0, .2);
      text-align: center;

      &::before {
        $iconSize: rem(40);
        content: '我的奖励金';
        display: inline-block;
        padding-left: rem(50);
        height: rem(42);
        line-height: rem(42);
        background: {
          image: url('../assets/images/money-header-icon.png');
          repeat: no-repeat;
          size: $iconSize $iconSize;
          position: left center;
        }
        font-size: rem(30);
        color: #945b26;
      }
      &-ciba {
        background: url('../assets/ciba/money-ciba-header.png') #fff center bottom no-repeat;
        &::before {
          background: none;
          padding-left: 0;
          color: #666666;
        }
      }
      // &::after {
      //     content: '每个月最多提现800~~';
      //     display: block;
      //     font-size: rem(24);
      //     color: #999;
      // }

      &-ques {
        position: absolute;
        top: rem(30);
        right: rem(30);
        padding-left: rem(28);
        background: {
          image: url('../assets/images/money-icon-mark.png');
          size: contain;
          position: left center;
          repeat: no-repeat;
        }
        font-size: rem(24);
        color: #ddb58b;
        &-ciba {
          background: {
            image: url('../assets/ciba/money-ciba-mark.png');
            size: contain;
            position: left center;
            repeat: no-repeat;
          }
          color: #999999;
        }
      }

      &-count {
        margin: rem(30) 0;
        font-size: rem(36);
        color: #ff6f25;

        & > span {
          font-size: rem(90);
        }
        &-ciba {
          color: #FF603A;
        }
      }

      &-link {
        $iconWidth: rem(10);
        display: inline-block;
        padding-right: $iconWidth * 2;
        background: {
          image: url('../assets/images/schedule-icon-arrow.png');
          repeat: no-repeat;
          size: $iconWidth $iconWidth * 2;
          position: right center;
        }
        font-size: rem(26);
        color: #666;
      }

      &-button {
        margin: rem(64) auto rem(16);
        padding: rem(20) 0;
        width: rem(214);
        border-radius: 5px;
        background-image: linear-gradient(to right, #ffb500, #f48f00);
        font-size: rem(30);
        color: #fff;
        &-ciba {
          background-image: linear-gradient(to right, #3BA8FF, #3BA8FF);
        }
      }
    }

    /** header end **/

    &-text {
      margin: rem(90) auto rem(40);
      width: rem(450);
      background: {
        image: url('../assets/images/money-text-bg.png');
        repeat: no-repeat;
        size: contain;
        position: center;
      }
      text-align: center;
      font-size: rem(30);
      color: #f48f00;
    }

    &-task {
      margin-bottom: rem(30);
      padding: rem(40) rem(30);
      border-radius: 8px;
      background-color: #fff;
      &-input {
        width: 100%;
        display: flex;
        align-items: baseline;
        justify-content: center;
        > input {
          height: rem(60);
          border-radius: rem(51.5);
          border: 1px solid #EFEFEF;
          font-size: rem(22);
          text-align: center;
          margin-top: rem(33);
          margin-bottom: rem(10);
          flex-grow: 1;
          padding-left: rem(23);
        }
        > span {
          line-height: rem(60);
          padding-left: rem(38);
          font-size: rem(30);
          color: #999;
        }
      }
      &-title {
        font-size: rem(30);
        color: #444;

        &::after {
          content: '邀请好友参加课程，多邀多得';
          display: inline-block;
          margin-left: rem(20);
          padding-left: rem(20);
          border-left: 1px solid #bfbfbf;
          font-size: rem(24);
          color: #bfbfbf;
        }
      }

      &-list {
        & > li {
          position: relative;
          padding: rem(30) 0 rem(24);

          // 边框
          &:not(:last-child) {
            &::before {
              content: '';
              transform: scaleY(.5);
              transform-origin: 0 1px;
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 1px;
              background-color: #e4e4e4;
            }
          }

          // 按钮
          &::after {
            content: '赚￥' attr(data-earning);
            position: absolute;
            right: 0;
            bottom: rem(24);
            padding: rem(12) rem(20);
            border-radius: 3px;
            background-color: #f48e01;
            font-weight: 600;
            font-size: rem(24);
            color: #fff;
          }

          & > div {
            display: inline-block;
            vertical-align: top;
            // max-width: rem(320);
            line-height: 1.5;

            &:first-child {
              width: rem(155);
              height: rem(190);
              background-size: 100% 100%;
              border-radius: 3px;
            }
          }
        }
        &-ciba {
          & > li {
            &::after {
              background-color: #3BA8FF;
              left: rem(185);
              right: auto;
            }
          }
        }
      }

      &-info {
        max-width: rem(440);
        margin-left: rem(30);

        &-title {
          font-size: rem(28);
          color: #333;
        }

        &-text {
          // max-width: rem(250);
          margin-top: rem(15);
          font-size: rem(22);
          color: #999;

          & > span {
            color: #ff5b34;
          }
        }
      }
    }

    /** task end **/

    &-popup {
      // transform: translate(-50%, -50%);
      // position: absolute;
      // top: 50%;
      // left: 50%;
      line-height: 1.5;
      text-align: center;

      &-box {
        padding: rem(40);
        border-radius: 3px;
        background-color: #fff;
      }

      &-close {
        $size: rem(80);
        margin: rem(60) auto 0;
        width: $size;
        height: $size;
        background: {
          image: url('../assets/images/live-icon-close.png');
          size: contain;
        }
      }

      &-icon {
        margin: 0 auto rem(24);

        &.success {
          $size: rem(100);
          width: $size;
          height: $size;
          background: {
            image: url('../assets/images/money-popup-icon.png');
            size: contain;
          }
        }

        &.id {
          width: rem(135);
          height: rem(80);
          background: {
            image: url('../assets/images/money-popup-icon-id.png');
            size: contain;
          }
        }

        &.heart {
          $size: rem(80);
          width: $size;
          height: $size;
          background: {
            image: url('../assets/images/money-popup-icon-heart.png');
            size: contain;
          }
        }
      }

      &-title {
        margin: 0 auto rem(30);
        width: rem(300);
        // background: {
        //     image: url('../assets/images/money-popup-title-bg.png');
        //     repeat: no-repeat;
        //     size: 100% 1px;
        //     position: center;
        // }
        font-size: rem(38);
        font-weight: 600;
        color: #333;
      }

      &-button {
        margin: rem(60) auto 0;
        padding: rem(10) 0;
        width: rem(260);
        line-height: 1.5;
        border-radius: 5px;
        background-image: linear-gradient(to right, #ffb500, #f48f00);
        font-size: rem(30);
        color: #fff;
      }

      &-question {
        width: rem(480);
        text-align-last: left;
        font-size: rem(28);
        color: #666;

        &:not(:last-child) {
          margin-bottom: rem(40);
        }

        & > p {
          text-align: left;

          &:first-child {
            font-weight: bold;
            color: #333;
          }
        }
      }

      &-text {
        margin: 0 rem(50);
        width: rem(380);
        font-size: rem(28);
        color: #666;

        & span {
          color: #f44d46;
        }
      }

      &-wx {
        margin: rem(40) auto rem(30);
        width: rem(240);
        // margin: rem(60) auto 0;
        // width: rem(345);
        // height: rem(132);
        // background: {
        //     image: url('../assets/images/money-popup-wx.png');
        //     size: contain;
        // }
      }

      &-tip {
        font: {
          weight: 500;
          size: rem(26);
        }
        color: #999;
      }
    }
  }
</style>
